import * as stylex from "@stylexjs/stylex";
import React from "react";
import { mapChildrenRec } from "../../lib/react.extended";
import { mkScrollyColorScale } from "../../materials";
import { layoutAreas, zIndex } from "../../materials/consts.stylex";
import { O } from "../../prelude";
import { ScrollyProvider, useScrolly } from "../scrolly";
import { Highlight } from "./highlight";
// -----------------------------------------------------------------------------
// ScrollyArea
export const ScrollyArea = React.memo(({ children })=>{
    const sections = React.useMemo(()=>{
        const set = new Set();
        React.Children.forEach(children, (child)=>{
            if (React.isValidElement(child)) {
                if (child.props && child.type === ScrollySection) {
                    set.add(child.props.id);
                }
            }
        });
        return set;
    }, [
        children
    ]);
    return <ScrollyProvider sections={sections}>
      <div className="x1n2onr6 x1lx81y2 xb9h7st">{children}</div>
    </ScrollyProvider>;
});
// -----------------------------------------------------------------------------
// ScrollySticky
export const ScrollySticky = React.memo(({ children })=>{
    return <div className="x7wzq59 x13vifvy x1ja2u2z x9d5c2t x1xhnyyv xpo3ry2 xs5nyxy x1azrkns xn12031">{children}</div>;
});
// -----------------------------------------------------------------------------
// ScrollySection
// "scrolly-section" resets paragraph children to inherit the surrounding text styling
// (see style.global.css) — StyleX can't express that descendant selector.
export const ScrollySection = React.memo(({ id: mbId, children })=>{
    const generatedId = React.useId();
    const id = mbId || generatedId;
    const { ref, sections } = useScrolly(id);
    const colorScale = React.useMemo(()=>{
        return mkScrollyColorScale(Array.from(sections.values()), O.some(id));
    }, [
        id,
        sections
    ]);
    return <div ref={ref} className={`scrolly-section ${({
        className: "x1n2onr6 x47corl x78zum5 xdt5ytf xl56j7k x6s0dn4 xb3hw6p xe1ab6z x1y7t761"
    }).className}`}>
      <ScrollySectionInner colorScale={colorScale}>{children}</ScrollySectionInner>
    </div>;
});
export const ScrollyStep = React.memo(({ id: mbId })=>{
    const generatedId = React.useId();
    const id = mbId || generatedId;
    const { ref } = useScrolly(id);
    return <div ref={ref} className={`scrolly-section ${({
        className: "x1n2onr6 x47corl x78zum5 xdt5ytf xl56j7k x6s0dn4 xb3hw6p xe1ab6z x1y7t761"
    }).className}`}/>;
});
const ScrollySectionInner = React.memo(({ children, colorScale })=>{
    const enhancedChildren = mapChildrenRec(children, (child)=>{
        return React.isValidElement(child) && child.type === Highlight && // <Highlight>
        Array.isArray(child.props.children) && typeof child.props.children[0] === "string" ? React.cloneElement(child, {
            color: colorScale(child.props.children[0])
        }) : child;
    });
    return <div className="x1n2onr6 x1cb1t30 xqb5aye x1ag4ua xp2v3zl x12oqio5 x2ra7ta xm6i5cn x55fcr">{enhancedChildren}</div>;
});
